'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.endMeasure = exports.startMeasure = exports.measure = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = require('recompose');

var _createEventHandler = require('recompose/createEventHandler');

var _rxjsObservableConfig = require('recompose/rxjsObservableConfig');

var _rxjsObservableConfig2 = _interopRequireDefault(_rxjsObservableConfig);

var _rxjs = require('rxjs');

var _metricsReporterProvider = require('./metricsReporterProvider');

var _metricsReporterProvider2 = _interopRequireDefault(_metricsReporterProvider);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultPredicate = function defaultPredicate() {
    return true;
};
var defaultMeasurePredicates = {
    start: defaultPredicate,
    end: defaultPredicate
};

var mapPropsStreamWithRxjsConfig = (0, _recompose.mapPropsStreamWithConfig)(_rxjsObservableConfig2.default);
var createEventHandlerRxjsConfig = (0, _createEventHandler.createEventHandlerWithConfig)(_rxjsObservableConfig2.default);

var toRx = function toRx(observable) {
    return _rxjs.Observable.from(observable);
};

var resolveName = function resolveName(measureName, props) {
    return typeof measureName === 'function' ? measureName(props) : measureName;
};

var measure = function measure(name) {
    var measurePredicates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var remeasurePolicy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'once';
    return (0, _recompose.compose)(mapPropsStreamWithRxjsConfig(function (props$) {
        var _createEventHandlerRx = createEventHandlerRxjsConfig(),
            setAfterRenderProps = _createEventHandlerRx.handler,
            afterRenderProps$ = _createEventHandlerRx.stream;
        //afterRenderProps$ = toRx(afterRenderProps$);


        var _defaultMeasurePredic = _extends({}, defaultMeasurePredicates, measurePredicates),
            startPredicate = _defaultMeasurePredic.start,
            endPredicate = _defaultMeasurePredic.end;

        var distinctFunc = remeasurePolicy === 'once' ? function (p) {
            return p;
        } : remeasurePolicy;
        var trigger$ = props$.distinctUntilChanged(undefined, distinctFunc);

        var _createEventHandlerRx2 = createEventHandlerRxjsConfig(),
            start = _createEventHandlerRx2.handler,
            start$ = _createEventHandlerRx2.stream;
        //start$ = toRx(start$);

        var actionDecoratedProps$ = props$;

        var actionCondition = function actionCondition() {
            return true;
        };
        if ((typeof startPredicate === 'undefined' ? 'undefined' : _typeof(startPredicate)) === 'object') {
            actionCondition = startPredicate.condition;
            startPredicate = startPredicate.action;
        }

        if (typeof startPredicate === 'string') {
            actionDecoratedProps$ = props$.map(function (props) {
                return _extends({}, props, _defineProperty({}, startPredicate, function () {
                    if (actionCondition(props)) {
                        start(Date.now());
                    }
                    return props[startPredicate].apply(props, arguments);
                }));
            });
        }

        var startFunction$ = void 0;
        if (typeof startPredicate === 'function') {
            startFunction$ = trigger$.filter(startPredicate).map(function () {
                return Date.now();
            });
        }

        var startTime$ = remeasurePolicy === 'once' ? startFunction$ ? startFunction$.take(1) : start$.take(1) : startFunction$ ? startFunction$ : start$;

        var endPredicate$ = startTime$.switchMap(function (startTime) {
            return endPredicate === 'unmount' ? afterRenderProps$.map(function () {
                return Date.now() - startTime;
            }).ignoreElements().finally(function () {
                return _metricsReporterProvider2.default.sendMeasure(name, Date.now() - startTime);
            }) : afterRenderProps$.filter(endPredicate).take(1).map(function () {
                return Date.now() - startTime;
            });
        }).do(function (gauge) {
            return _metricsReporterProvider2.default.sendMeasure(name, gauge);
        }).ignoreElements().startWith(null);

        return _rxjs.Observable.combineLatest(actionDecoratedProps$, endPredicate$, start$.startWith(null), function (props) {
            return _extends({}, props, {
                setAfterRenderProps: setAfterRenderProps
            });
        });
    }), (0, _recompose.lifecycle)({
        componentDidMount: function componentDidMount() {
            this.props.setAfterRenderProps(this.props);
        },
        componentDidUpdate: function componentDidUpdate(prevProps) {
            this.props.setAfterRenderProps(this.props);
        }
    }), (0, _recompose.mapProps)(function (_ref) {
        var setAfterRenderProps = _ref.setAfterRenderProps,
            props = _objectWithoutProperties(_ref, ['setAfterRenderProps']);

        return props;
    }));
};

exports.measure = measure;
var startedMeasure = {};
var getMeasureId = function getMeasureId(name, idExtractor) {
    var id = idExtractor ? idExtractor() : undefined;
    return id ? { fullId: name + '_' + id, id: id } : { fullId: name };
};

var startMeasure = exports.startMeasure = function startMeasure(measureName, idExtractor) {
    var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultPredicate;
    var startMeasurePolicy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'none';
    return (0, _recompose.compose)(mapPropsStreamWithRxjsConfig(function (props$) {
        var _createEventHandlerRx3 = createEventHandlerRxjsConfig(),
            start = _createEventHandlerRx3.handler,
            start$ = _createEventHandlerRx3.stream;
        //start$ = toRx(start$);


        var trigger$ = props$.distinctUntilChanged();
        var actionDecoratedProps$ = props$;

        var actionCondition = function actionCondition() {
            return true;
        };
        var startPredicate = predicate;

        if ((typeof predicate === 'undefined' ? 'undefined' : _typeof(predicate)) === 'object') {
            actionCondition = predicate.condition;
            startPredicate = predicate.action;
        }

        if (typeof startPredicate === 'string') {
            actionDecoratedProps$ = props$.map(function (props) {
                return _extends({}, props, _defineProperty({}, startPredicate, function () {
                    if (actionCondition(props)) {
                        start(Date.now());
                    }
                    return props[startPredicate].apply(props, arguments);
                }));
            });
        }

        var startFunction$ = void 0;

        if (typeof startPredicate === 'function') {
            startFunction$ = trigger$.filter(startPredicate).map(function () {
                return Date.now();
            });
        }

        var startTime$ = startFunction$ ? startFunction$.take(1) : start$.take(1);
        var startTimeWithProps$ = _rxjs.Observable.combineLatest(props$, startTime$, function (props, startTime) {
            return {
                props: props,
                startTime: startTime
            };
        });

        var startPredicate$ = startTimeWithProps$.do(function (_ref2) {
            var props = _ref2.props,
                startTime = _ref2.startTime;

            var id = getMeasureId(resolveName(measureName, props), idExtractor ? function () {
                return idExtractor(props);
            } : null);
            if (!startedMeasure.measureName || startMeasurePolicy === 'singlePerMeasure') {
                startedMeasure.measureName = {};
            }
            if (!startedMeasure.measureName[id.fullId]) {
                startedMeasure.measureName[id.fullId] = startTime;
            }
        });

        return _rxjs.Observable.combineLatest(actionDecoratedProps$, startPredicate$.startWith(null), start$.startWith(null), function (props) {
            return _extends({}, props);
        });
    }));
};

var endMeasure = exports.endMeasure = function endMeasure(measureName, idExtractor) {
    var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultPredicate;
    var overrideMeasureNamePredicate = arguments[3];
    return (0, _recompose.lifecycle)({
        checkAndSend: function checkAndSend(checkPredicate, extractor) {
            if (checkPredicate(this.props)) {
                this.sendMeasure(extractor);
            }
        },
        sendMeasure: function sendMeasure(extractor) {
            var resolvedName = resolveName(measureName, this.props);
            var id = getMeasureId(resolvedName, extractor);
            if (!startedMeasure.measureName || !startedMeasure.measureName[id.fullId]) {
                return;
            }
            var sendMeasureName = overrideMeasureNamePredicate ? overrideMeasureNamePredicate(this.props) : resolvedName;
            _metricsReporterProvider2.default.sendMeasure(sendMeasureName, Date.now() - startedMeasure.measureName[id.fullId], id.id);
            delete startedMeasure.measureName[id.fullId];
        },
        componentDidMount: function componentDidMount() {
            var _this = this;

            if (typeof predicate === 'function') {
                var checkPredicate = function checkPredicate() {
                    return predicate(_this.props, {});
                };
                var extractor = idExtractor ? function () {
                    return idExtractor(_this.props, {});
                } : null;
                this.checkAndSend(checkPredicate, extractor);
            }
        },
        componentDidUpdate: function componentDidUpdate(prevProps) {
            var _this2 = this;

            if (typeof predicate === 'function') {
                var checkPredicate = function checkPredicate() {
                    return predicate(_this2.props, prevProps);
                };
                var extractor = idExtractor ? function () {
                    return idExtractor(_this2.props, prevProps);
                } : null;
                this.checkAndSend(checkPredicate, extractor);
            }
        },
        componentWillUnmount: function componentWillUnmount() {
            var _this3 = this;

            if (predicate === 'unmount') {
                var extractor = idExtractor ? function () {
                    return idExtractor(_this3.props);
                } : null;
                this.sendMeasure(extractor);
            }
        }
    });
};